import * as yup from 'yup';

export const getUpdateStatusProspectSchema = yup.object().shape({
  status: yup.string().required('Ce champs est requis'),
  comment: yup.string().required('Ce champs est requis'),
  reminder_date: yup.string() || undefined,
});
